import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";

@NgModule({
  declarations: [],
  imports: [CommonModule]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: []
    };
  }
}
